@if (response && response.type === 'success') {
    <sirius-text-html
        #responseEl
        class="sir-form-response"
        [html]="response.message"
        textStyle="paragraph"
        textStyleSize="l"></sirius-text-html>
} @else {
    <!--
        The form stays mounted across submissions so its FormGroup state and
        the consent checkboxes (which seed their control value in ngOnInit
        when un-checked) survive submit/error round-trips. The submission
        spinner is rendered as a sibling overlay below; CSS positions it on
        top of the form so the form can stay in the DOM during the request.
    -->
    <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        [id]="id"
        [attr.aria-busy]="(isSubmitting$ | async) === true ? 'true' : null"
        data-zoominfo-id="1">
        @for (group of formElementGroups; track $index) {
            <div
                [class]="'sir-form-group-container ' + (group.groupClassNames?.join(' ') ?? '')"
                [class.is-last]="$index === formElementGroups.length - 1">
                @for (field of group.formFields; track $index) {
                    <div class="sir-form-field">
                        <div class="sir-form-field-inputs">
                            <ng-template siriusDynamicFormElement [config]="field"></ng-template>
                        </div>
                        @if (field.componentName !== 'form-textarea') {
                            <div
                                class="sir-form-tooltip sir-text-style-system-s-default sir-text-style-color-secondary">
                                {{ field.toolTip }}
                            </div>
                        }
                    </div>
                }
            </div>
        }

        <div class="sir-form-notice-container">
            @if (infoHtmlKey) {
                <sirius-text-html
                    class="sir-form-notice"
                    [html]="infoHtmlKey | translate"
                    textStyle="paragraph"
                    textStyleSize="s"></sirius-text-html>
            }

            <sirius-text-html
                class="sir-form-required-notice"
                [html]="'form.requiredFieldsNotice' | translate"
                textStyle="paragraph"
                textStyleSize="s"></sirius-text-html>
        </div>

        <div class="sir-form-actions">
            @if (hasCancelButton) {
                <button
                    siriusButton
                    size="small"
                    [buttonText]="cancelButtonText || 'button.cancel' | translate"
                    (click)="onCancel()"></button>
            }
            <button
                siriusButton
                [disabled]="(isSubmitting$ | async) === true"
                type="submit"
                [buttonText]="buttonText || 'button.next' | translate"
                [buttonType]="'primary'"
                [tracking]="tracking"
                [iconName]="hasButtonIcon ? 'arrow_right' : undefined"
                [iconPos]="'right'"></button>
        </div>
    </form>

    @if ((isSubmitting$ | async) === true) {
        <div class="sir-spinner-overlay" aria-live="polite">
            <sirius-spinner></sirius-spinner>
        </div>
    }
}
